export const AppConstants = {
  MAX_ATTEMPTS_RESET_MESSAGE:"Looks like you have forgotten your password. You can reset it here or go back and try again.",
  HELP_DESK: {
    NUMBER: "1-866-344-7039",
    EMAIL: "helpdesk@statline.org"
  },
  STATLINE_ORG_ID: 194,
  MAX_DATE_RANGE_DAYS: 365,
  PASSWORD_EXPIRATION_WARNING_AUTO_CLOSE_TIME_IN_SECONDS: 10,
};
